// extracted by mini-css-extract-plugin
export default {"page-header":"Assignments_page-header__3tio1","add-assignment-btn":"Assignments_add-assignment-btn__SW6OE","assignment-list":"Assignments_assignment-list__LQROl"};